export default __webpack_public_path__ + "static/media/germany.16debde8.svg";